import React, { useEffect, useState } from "react";
import { isEmpty, isObject, isArray } from "lodash";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  getBLOGList,
  deleteBLOG,
  changeStatus,
  resetComponentStore,
} from "actions/admin/blog";
import * as Constants from "constants/index";
import DataTable from "react-data-table-component";
import FilterComponent from "./Filters";

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  FormGroup,
  CardHeader,
} from "reactstrap";
import Spinner from "views/components/Spinner";
import styled from "styled-components";
import { FaAngleDown, FaAngleUp, FaPencilAlt, FaTrash } from "react-icons/fa";

const Stack = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || "row"};
  align-items: ${(props) => props.alignItems || "initial"};
  -webkit-box-align: center;
  & > div:not(:first-child) {
    margin: 0px;
    margin-left: ${(props) =>
      props.direction !== "column" ? (props.gap || 1) * 8 + "px" : "0px"};
  }
`;

const getValue = (data) => {
  if (isObject(data) && data.hasOwnProperty("value")) return data.value;
  else if (isArray(data)) return data.map((obj) => obj.value);
  return data;
};

const addFilters = (element, filters) => {
  const set = new Set(filters);
  set.add(element);
  return Array.from(set);
};

const removeFilter = (element, filters) => {
  const set = new Set(filters);
  set.delete(element);
  return Array.from(set);
};

const BLOGList = ({
  getBLOGList,
  deleteBLOG,
  history,
  blogList: { data, count, page },
  sortingParams,
  changeStatus,
  performDelete,
  loading,
  loadingListData,
  resetComponentStore,
}) => {
  const initialSortingParams = {
    limit: 30,
    page: 1,
    orderBy: "updated_at",
    ascending: "desc",
    query: "",
    filters: [],
    count: count,
  };
  const [blogParams, setBLOGParams] = useState({
    limit: sortingParams.limit,
    page: sortingParams.page,
    orderBy: sortingParams.orderBy,
    ascending: sortingParams.ascending,
    query: sortingParams.query,
    filters: sortingParams.filters,
    count: count,
  });
  console.log(data);
  const [onlyOnce, setOnce] = useState(true);
  const [filterOpen, setFilterOpen] = useState(false);

  let delayTimer;

  // const headerSortingStyle = { backgroundColor: '#c8e6c9' };
  // Removed and Replaced from sizePerPageRenderer
  // const sizePerPageOptionRenderer = ({ text, page, onSizePerPageChange }) => (
  //   <li
  //     key={text}
  //     role="presentation"
  //     className="dropdown-item"
  //     onMouseDown={e => {
  //       e.preventDefault();
  //       onSizePerPageChange(page);
  //     }}
  //   >
  //     <Button
  //       tabIndex="-1"
  //       role="menuitem"
  //       data-page={page}
  //       className="sizePerPageaTag"
  //     >
  //       {text}
  //     </Button>
  //   </li>
  // );

  const columns = [
    // {
    //   name: "BLOG slug",
    //   minWidth: "150px",
    //   sortable: true,
    //   selector: (row) => row.slug,
    // },
    // {
    //   name: "Page Name",
    //   minWidth: "150px",
    //   sortable: true,
    //   selector: (row) => row.name,
    // },
    {
      name: "Page Title",
      width: "350px",
      sortable: true,
      selector: (row) => row.title,
    },
    {
      name: "Category",
      minWidth: "150px",
      sortable: true,
      selector: (row) => row.category,
    },
    {
      name: "Updated At",
      minWidth: "150px",
      sortable: true,
      selector: (row) => row.updatedAt,
      // headerSortingStyle,
      format: (cellContent, row) => moment(cellContent.updatedAt).format("ll"),
    },
    {
      name: "Actions",
      selector: (row) => row,
      minWidth: "150px",
      format: (cellContent, row) => (
        <div>
          <Link to={`/home/blog/${cellContent._id}`} title="edit/view">
            <Button
              type="button"
              style={{ marginLeft: 4, color: "white" }}
              size="sm"
              color="success"
            >
              <FaPencilAlt />
            </Button>
          </Link>
          <Button
            type="button"
            size="sm"
            color="danger"
            style={{ marginLeft: 4, color: "white" }}
            onClick={(e) => {
              if (
                window.confirm(
                  `Are you sure you want to delete :\r ${cellContent.title}?`
                )
              ) {
                deleteBLOG(cellContent._id, history);
              }
            }}
          >
            <FaTrash />
          </Button>
        </div>
      ),
    },
  ];

  const handleSearch = (e, onSearch, searchDelay) => {
    clearTimeout(delayTimer);
    const text = e.target.value;
    delayTimer = setTimeout(() => {
      onSearch(text);
    }, searchDelay);
  };

  const defaultSorted = [
    {
      dataField: "created_at",
      order: "desc",
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <span className="custom-paginator">
      <span>Records per page: </span>
      <UncontrolledDropdown tag="span">
        <DropdownToggle caret className="dropdown-btn-col-w dropdown-p-28">
          {currSizePerPage}
        </DropdownToggle>
        <DropdownMenu>
          {options.map((option) => (
            <DropdownItem
              tag="li"
              key={option.text}
              onMouseDown={(e) => {
                e.preventDefault();
                onSizePerPageChange(option.page);
              }}
            >
              {option.text}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </span>
  );

  const options = {
    page: parseInt(blogParams.page),
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page

    showTotal: true,
    paginationTotalRenderer: customTotal,
    totalSize: count,
    sizePerPageRenderer,
    //sizePerPageOptionRenderer,
    sizePerPageList: [
      {
        text: Constants.DEFAULT_PAGE_SIZE,
        value: Constants.DEFAULT_PAGE_SIZE,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
        value: count,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, searchText, sortField, sortOrder }
  ) => {
    let params = {
      page: type === "search" ? 1 : page || 1,
      limit: sizePerPage,
      orderBy: sortField,
      ascending: sortOrder,
      filters: sortingParams.filters,
      query: sortingParams.query,
      // query: type === "search" ? searchText : blogParams.query,
    };
    //console.log(params);
    // getBLOGList(params);
    let filters = [];
    if (type === "search") {
      if (searchText.length > 0) {
        filters = sortingParams.filters.includes(type)
          ? sortingParams.filters
          : [...sortingParams.filters, type];
        params = {
          ...params,
          query: {
            ...sortingParams.query,
            [type]: {
              value: searchText,
              type: "String",
            },
          },
          filters,
        };
      } else {
        filters = sortingParams.filters.filter((item) => item !== type);
        const temp = {};
        params = {
          ...sortingParams,
          filters,
        };
        for (var i in params.query) {
          if (i === type) continue;
          temp[i] = params.query[i];
        }
        params.query = temp;
      }
    }
    setBLOGParams((param) => ({ ...param, ...params }));
  };
  useEffect(() => {
    let subscribe = true;
    let updateTimer;
    const asyncParams = async () => {
      try {
        if (subscribe) {
          if (onlyOnce) {
            resetComponentStore();
            setOnce(false);
          }
          getBLOGList(blogParams);
          // updateTimer = setInterval(function() {
          //   getBLOGList(blogParams);
          // }, process.env.REACT_APP_UPDATE_LIST_TIMER);
        }
      } catch (err) {
        // throw err;
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
      clearInterval(updateTimer);
    };
  }, [getBLOGList, blogParams, resetComponentStore, onlyOnce]);

  useEffect(() => {
    /**
     * Due to asynchronous behavior it is possible that we are dealing with
     * Old value using setState({...params, propery:value });
     * So, to eliminate this situation we are doing function update such as below
     */
    let subscribe = true;
    const asyncParams = async () => {
      if (subscribe) {
        performDelete &&
          setBLOGParams((params) => ({
            ...params,
            ...sortingParams,
            page: parseInt(page),
          }));
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
    };
  }, [page, performDelete, sortingParams]);

  const onSearch = (text) => {
    handleTableChange("search", {
      searchText: text,
      sizePerPage: blogParams.limit,
      sortOrder: blogParams.ascending,
    });
  };
  const handleSort = (column, sortDirection) => {
    const orderBy = column.field;
    setBLOGParams((prevParams) => ({
      ...prevParams,
      orderBy,
      ascending: sortDirection,
    }));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setBLOGParams((prevParams) => ({
      ...prevParams,
      limit: newPerPage,
      page,
    }));
  };

  const onFilterChange = (name, value) => {
    setBLOGParams((params) => {
      let filters = [];
      let query = params.query || {};
      if (isEmpty(value)) {
        filters = removeFilter(name, params.filters);
        delete query[name];
      } else {
        filters = addFilters(name, params.filters);
        query[name] = {
          value: getValue(value),
          type: "String",
        };
      }
      const filterParams = {
        filters,
        query,
      };
      return {
        ...params,
        ...filterParams,
      };
    });
  };

  const handlePageChange = async (page) => {
    setBLOGParams((prevParams) => ({ ...prevParams, page }));
  };
  return loading ? (
    <Spinner />
  ) : (
    <div className="animated fadeIn" style={{ marginTop: "5%" }}>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <Stack
                alignItems="center"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <h2>BLOG List</h2>
                </div>
                <div className="add-button-div">
                  <Link to="/home/blog/create" title="create">
                    <Button color="primary" size="sm">
                      <i className="fa fa-plus"></i> Add New Blog
                    </Button>
                  </Link>
                </div>
              </Stack>
            </CardHeader>
            <CardBody>
              <div className="add-button-div border-bottom">
                <div
                  className="filters-row"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <h5>Filters</h5>
                  </div>
                  <div onClick={() => setFilterOpen(!filterOpen)}>
                    {filterOpen ? (
                      <FaAngleUp
                        style={{
                          height: 35,
                          marginRight: 15,
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      <FaAngleDown
                        style={{
                          height: 35,
                          marginRight: 15,
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <DataTable
                columns={columns}
                data={data}
                subHeader={filterOpen}
                subHeaderComponent={
                  <FilterComponent
                    onSearch={onSearch}
                    onFilter={onFilterChange}
                  />
                }
                progressPending={loadingListData}
                pagination
                paginationServer
                onSort={handleSort}
                sortServer
                paginationTotalRows={count}
                paginationRowsPerPageOptions={[30, 60, 90]}
                paginationPerPage={blogParams.limit ? blogParams.limit : 30}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

BLOGList.propTypes = {
  getBLOGList: PropTypes.func.isRequired,
  deleteBLOG: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  blogList: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  sortingParams: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  blogList: state.blog.blogList,
  loading: state.blog.loadingBLOGList,
  sortingParams: state.blog.sortingParams,
  performDelete: state.blog.performDelete,
  loadingListData: state.blog.loadingListData,
});

export default connect(mapStateToProps, {
  getBLOGList,
  deleteBLOG,
  changeStatus,
  resetComponentStore,
})(BLOGList);
